// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AsAH","question":"styles_question__1Ukwh","inputVisibleButton":"styles_inputVisibleButton__2jkW-","note":"styles_note__3S6P4"};